import { GridAll } from '@progress/kendo-vue-grid/dist/npm/Grid';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class GridFilter extends Vue {
    @Prop() public grid: GridAll;
    @Prop() public field: string;
    @Prop() public filterType: string;
    @Prop() public value: any;

    public filterOperator: string = 'contains';
    public filterValue: string = '';

    public mounted() {
        this.filterValue = this.value;
    }

    public change(ev) {
        this.$emit('change', {
            operator: this.filterOperator,
            field: this.field,
            value: this.filterValue,
            syntheticEvent: ev,
        });
    }

    public reset(ev) {
        this.$emit('change', {
            operator: '',
            field: '',
            value: '',
            syntheticEvent: ev,
        });
    }
}
